@if (affiliation$ | async; as affiliation) {
  <div class="formgrid grid mx-3 mt-3">
    <div class="field col-12 mb-5">
      <label for="addressLine1"
             class="font-bold"
             i18n>Address Line 1</label>
      <input scValidatable
             id="addressLine1"
             type="text"
             pInputText
             [(ngModel)]="affiliation.addressLine1"
             [disabled]="true"
             class="w-full">
    </div>
    <div class="field col-12 mb-5">
      <label for="city"
             class="font-bold"
             i18n>City</label>
      <input scValidatable
             id="city"
             type="text"
             pInputText
             [(ngModel)]="affiliation.city"
             [disabled]="true"
             class="w-full">
    </div>
    <div class="field col-7 mb-5">
      <label for="countryId"
             class="font-bold"
             i18n>Country</label>
      <p-select id="countryId"
                [options]="countries$ | async"
                [virtualScroll]="true"
                [virtualScrollItemSize]="50"
                [showClear]="true"
                [(ngModel)]="affiliation.countryId"
                [disabled]="true"
                styleClass="w-full">
      </p-select>
    </div>
    <div class="field col-5 mb-5">
      <label for="zip"
             class="font-bold"
             i18n>ZIP</label>
      <input scValidatable
             id="zip"
             type="text"
             pInputText
             [(ngModel)]="affiliation.zip"
             [disabled]="true"
             class="w-full">
    </div>
    <div class="field col-6 mb-5">
      <label for="universityOrOrganization"
             class="font-bold"
             i18n>University/Organization</label>
      <input scValidatable
             id="universityOrOrganization"
             type="text"
             pInputText
             [(ngModel)]="affiliation.universityOrOrganization"
             [disabled]="true"
             class="w-full">
    </div>
    <div class="field col-6 mb-5">
      <label for="department"
             class="font-bold"
             i18n>Department</label>
      <input scValidatable
             id="department"
             type="text"
             pInputText
             [(ngModel)]="affiliation.department"
             [disabled]="true"
             class="w-full">
    </div>
  </div>
}